import { cssVars } from "@faire/slate/lib/cssVars";
import React from "react";
import {
  cssTransition,
  Slide,
  ToastContainer as ToastifyContainer,
  ToastContainerProps,
  ToastPosition,
} from "react-toastify";

import {
  TOAST_CONTAINER_DESKTOP_ID,
  TOAST_CONTAINER_MOBILE_ID,
} from "./consts";

type IProps = {
  /**
   * **web**
   * The css top position of the toast container.
   */
  top?: string;

  /**
   * **web**
   * The position of the toast container on desktop.
   *
   * @default "top-right"
   */
  desktopPosition?: ToastPosition;

  /**
   * **web**
   * The css bottom position of the toast container on mobile.
   *
   * @default "env(safe-area-inset-bottom)" on phone widths, otherwise 16px
   */
  bottom?: string;

  // DO NOT ADD any new prop without aligning with Slate team first
};

/**
 * The container for rendering toasts.
 */
export const ToastContainer: React.FC<IProps> = ({
  top,
  desktopPosition = "top-right",
  bottom,
}) => {
  const style = containerVars({ top });
  // Inline because react-toastify's phone-width rule sets `bottom` directly
  // and ignores --toastify-toast-bottom.
  const mobileStyle = bottom === undefined ? undefined : { bottom };
  return (
    <>
      <ToastifyContainer
        {...commonProps}
        className="fs-toast-container hidden! md:flex!"
        style={style}
        transition={Slide}
        position={desktopPosition}
        containerId={TOAST_CONTAINER_DESKTOP_ID}
      />
      <ToastifyContainer
        className="fs-toast-container flex md:hidden!"
        {...commonProps}
        style={mobileStyle}
        transition={VericalSlide}
        position="bottom-center"
        containerId={TOAST_CONTAINER_MOBILE_ID}
      />
    </>
  );
};

const commonProps: ToastContainerProps = {
  draggable: true,
  closeButton: false,
  hideProgressBar: false,
  newestOnTop: true,
  "aria-label": undefined,
};

const VericalSlide = cssTransition({
  enter: "Toastify__slide-enter--bottom-center",
  exit: "Toastify__slide-exit--bottom-center",
  collapse: false,
  collapseDuration: 0,
  appendPosition: false,
});

const containerVars = cssVars({
  vars: {
    top: "toastify-toast-top",
  },
});
